import { useState } from 'react';
import { IonContent, IonPage, IonIcon, IonCard, IonCardHeader, IonCardSubtitle, IonList, IonItem, IonLabel, IonButton, IonInput, IonAlert, IonLoading, useIonViewWillLeave, useIonAlert, IonCol, IonGrid, IonImg, IonRow, IonSelect, IonSelectOption, IonCheckbox, IonSpinner, useIonViewWillEnter, IonRefresher, IonRefresherContent, IonHeader, IonToolbar, IonTitle, IonButtons } from '@ionic/react';
import { eye, copy, arrowUpCircle, add, arrowDownCircle, refresh, wallet, walletOutline, walletSharp, enter, timeOutline, camera } from 'ionicons/icons';
import {
  Token,
  TOKEN_PROGRAM_ID
} from '@solana/spl-token';
import {
  AccountInfo,
  ComputeBudgetProgram,
  Connection,
  Keypair,
  LAMPORTS_PER_SOL,
  ParsedAccountData,
  PublicKey,
  SystemProgram,
  Transaction,
} from '@solana/web3.js';
import UserService from '../../services/user';
import './Wallet.css';
import Config from '../../config/settings';
import CopyToClipboard from 'react-copy-to-clipboard';
import QRCode from 'react-qr-code';
import Accounts from '../../config/wallets';
import { PrioritizationFeeObject, WalletService } from './Wallet.svc';
import * as bip39 from "bip39";
import { Subscription } from 'rxjs';
import { Shared } from '../../shared/shared';
import QrReader from 'react-qr-scanner';
import { AppVersion } from '@awesome-cordova-plugins/app-version';
import UpdateService from '../../services/update';
import { Utils } from '../../shared/utils';
import { Transactions } from '../../config/transactions';
import { ParsedAccount, TokenAmount } from '../../models/parsedAccount';

const Wallet: React.FC<{  shared?: Shared, userService?: UserService, updateService?: UpdateService, isAndroidDevice: boolean }> = ({ shared, userService, updateService, isAndroidDevice }) => {

  const [email, setEmail] = useState<string>();
  const [security, setSecurity] = useState<string>();
  // const [connectedWalletPubkey, setConnectedWalletPubkey] = useState<string>();
  const [pubkey, setPubkey] = useState<string>();
  const [seedkey, setSeedkey] = useState<string>();
  const [seedkeyString, setSeedkeyString] = useState<string>('');
  // const [remainingJoinDays, setRemainingJoinDays] = useState<string>('');
  const [walletBalanceSOL, setWalletBalanceSOL] = useState<string>('0.000');
  const [walletBalanceNSA, setWalletBalanceNSA] = useState<string>('0.000');
  const [walletBalanceNSAN, setWalletBalanceNSAN] = useState<string>('0.000');
  // const [inAppWalletBalanceSOL, setInAppWalletBalanceSOL] = useState<string>('0.000');
  // const [inAppWalletBalanceNSA, setInAppWalletBalanceNSA] = useState<string>('0.000');
  // const [inAppWalletBalanceNSAN, setInAppWalletBalanceNSAN] = useState<string>('0.000');
  const [isDevise, setDevise] = useState<string>();
  const [webTransacions = false, setWebTransactions] = useState<boolean>(false);
  const [showAlertConnection, setShowAlertConnexion] = useState(false);
  const [needNSAaccount, setNeedNSAaccount] = useState<boolean>(true);
  const [needNSANaccount, setNeedNSANaccount] = useState<boolean>(true);
  const [showSendForm = false, setShowSendForm] = useState<boolean>(false);
  const [showInAppWallet = false, setShowInAppWallet] = useState<boolean>(false);
  const [showInAppSendForm = false, setInAppShowSendForm] = useState<boolean>(false);
  const [showDepositForm = false, setShowDepositForm] = useState<boolean>(false);
  const [showBuyForm = false, setShowBuyForm] = useState<boolean>(false);
  // const [showLabelForm = false, setShowLabelForm] = useState<boolean>(true);
  const [showAlertSeedKey = false, setShowAlertSeedKey] = useState<boolean>(false);
  const [isLoadingWallet = false, setIsLoadingWallet] = useState<boolean>(false);
  const [showLoadingDots = false, setShowLoadingDots] = useState<boolean>(false);
  const [isRefreshing = false, setRefreshing] = useState<boolean>(false);
  const [transferToInAppChecked, setTransferToInAppChecked] = useState(false);
  // const [nsanModal = false, showNSANModal] = useState<boolean>(false);
  const [reduction, setReduction] = useState<string>('0');
  // eslint-disable-next-line 
  const [remaining, setRemaining] = useState<string>('0');
  const [totalNSASent, setTotalNSASent] = useState<string>('0');
  // eslint-disable-next-line 
  const [totalNSANSent, setTotalNSANSent] = useState<string>('0');
  const [total, setTotal] = useState<number>(0.000);
  const [walletContent, setWalletContent] = useState<WalletContent[]>([]);
  const [inAppWalletContent, setInAppWalletContent] = useState<WalletContent[]>([]);
  const [amount, setAmount] = useState<string>('0');
  const [transactionAddress, setTransactionAddress] = useState<string>('');
  const [transactionAmount, setTransactionAmount] = useState<string>('0');
  const [computeUnits, setComputeUnits] = useState<number>(Transactions.computerUnits);
  // eslint-disable-next-line 
  const [microLamports, setMicroLamports] = useState<number>(Transactions.microLamports);
  const [priorityFee, setPriorityFee] = useState<number>(0.000025);
  const [preSaleStatus, setPreSaleStatus] = useState<string>('Closed');
  // const [transactionFee, setTransactionFee] =  useState<number>(0);
  const [sendTransactionBtnDisabled = false, setSendTransactionBtnDisabled] = useState<boolean>(false);
  const [minSolToBuy, setSolLimit] = useState<number>(0);
  const [presentAlert] = useIonAlert();
  const [coingeckoLogo, setCoingeckoLogo] = useState<string>('primary');
  const [isOpenQRScan, setOpenQrScan] = useState<boolean>(false);
  const [inAppCurrency, setInAppCurrency] = useState<string>('nsa');
  const [showUpdateDownload, setShowUpdateDownload] = useState<boolean>(false);
  const [showDownload, setShowDownload] = useState<boolean>(false);

  const decimals = 1000000000;
  const startPrice = 0.015727272;
  const accountPubkey = Config.accountPubkey;
  
  const walletService: WalletService = new WalletService();

  const connectionMainnet = new Connection(
    Utils.selectRpcHost('constantK'),
    {
      commitment: 'confirmed',
      wsEndpoint: Utils.selectRpcHost('constantK', true)
    }
  );

  const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;

  let userServiceSubscribe: Subscription;

  useIonViewWillEnter(async () => {

    // On affiche le wallet mainnet par défaut
    showHideWallet(false);

    userServiceSubscribe = userService.storageInitSubject.subscribe(async (result) => {
      if (result === true) {
        // recupération des données
        setPubkey(userService.pubkey);
        setSeedkey(userService.seedkey);
        setEmail(userService.email);
        setSecurity(userService.security);

        if (webTransacions === false) {  
          setWebTransactions(true);

          if (userService.walletContentCalled === true) {
            setWalletContent(userService.getWalletContentData());
          } else {
            refreshWallet();
          }
        }

        // Check and update
        if (await AppVersion?.getVersionNumber().then(() => true).catch(() => false)) {
          setShowUpdateDownload(await updateService.checkUpdate(userService).then(res => res));
        }
        //test
        setShowUpdateDownload(await updateService.checkUpdate(userService).then(res => res));
      }
    });
    // setPreSaleStatus('Wait opening');
    setPreSaleStatus('Open');
    //setPreSaleStatus('Closed');
  })

  useIonViewWillLeave(() => {
    if (userServiceSubscribe) {
      userServiceSubscribe.unsubscribe();
    }
  })

  function handleScan(data){
    // console.log('scan data: ', data);

    if (data !== null && data.text) {
      setTransactionAddress(data.text);
      setOpenQrScan(false);
    }
  }

  /**
   * Explorer une adresse
   */
  function exploreAddress(address?: string) {
    if (pubkey) {
      window.open(`https://solscan.io/account/${(address) ? address : userService.pubkey}`);
      // window.open(`https://explorer.solana.com/address/${(address) ? address : userService.pubkey}?cluster=mainnet`);
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'You have to create a wallet on Solana Mainnet.',
        buttons: ['OK'],
      });
    }
  }

  /**
   * Afficher la box send
   */
  function showSend() {
    if (pubkey) {
      setShowBuyForm(false);
      setShowDepositForm(false);
      // setShowLabelForm(false);
      setInAppShowSendForm(false);
      if (showSendForm === false) {
        setShowSendForm(true);
      } else {
        setShowSendForm(false);
      }
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'You have to create a wallet on Solana Mainnet.',
        buttons: ['OK'],
      });
    }
  }

  function showInAppSend() {
    if (showInAppSendForm === true) {
      setInAppShowSendForm(false);
    } else {
      setInAppShowSendForm(true);
    }
  }

  /**
   * Afficher la box deposit
   */
  function showDeposit() {
    if (pubkey) {
      setShowBuyForm(false);
      setShowSendForm(false);
      // setShowLabelForm(false);
      setInAppShowSendForm(false);
      if (showDepositForm === false) {
        setShowDepositForm(true);
      } else {
        setShowDepositForm(false);
      }
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'You have to create a wallet on Solana Mainnet.',
        buttons: ['OK'],
      });
    }
  }

  /**
   * Afficher la box Join pre-sale
   */
  function showBuy() {
    if (pubkey) {
      if (showBuyForm === false) {
        setShowBuyForm(true);
      } else {
        setShowBuyForm(false);
      }
      setShowSendForm(false);
      // setShowLabelForm(false);
      setShowDepositForm(false);
      setInAppShowSendForm(false);

      updatePresaleData();
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'You have to create a wallet on Solana Mainnet by pressing the "Create" button.',
        buttons: ['OK'],
      });
    }
  }

  /**
   * Flouter les données du wallet
   */
  function hideValue() {
    const deviseValues = document.getElementsByClassName('devise-value');

    if (deviseValues && deviseValues.length > 0) {
      for (let index = 0; index < deviseValues.length; index++) {
        const element = deviseValues[index];
        if (element?.classList.contains('compteur-hidden')) {
          element?.classList.remove('compteur-hidden');
        } else {
          element?.classList.add('compteur-hidden');
        }
      }
    }
      
  }

  /**
   * Récupération de la balance du wallet Solana
   */
  async function getSolanaBalance() {

    if (userService && userService.pubkey) {

      return walletService
        .getSolanaBalance(
          userService.pubkey
        ).then(
          async (res) => {
  
            const resultat = await res.json();
            
            let balance = (resultat?.result?.value) ? resultat?.result?.value : 0;
            
            // Parser la balance en valeur réelle
            return await traitementBalance(balance);
          }
        ).catch((_e: any) => {
          setIsLoadingWallet(false);
          const formatError = _e.toString().indexOf('NetworkError') > -1
            ? 'Impossible to access network, please check your internet access and restart the app or click on refresh button.' 
            : _e;
          console.log('error', _e);
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: 'Error ' + formatError,
            buttons: ['OK'],
          });
        });
    }

    return null;
  }

  /**
   * Récupération des compte du wallet In-App
   */
  function getInAppAccounts() {

    // Récupération contenu in-app wallet
    const url = baseUrl + 'get-inapp-wallet?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;

    fetch(url, { signal: AbortSignal.timeout(5000) }).then(
      async (res) => {
        const result = await res.json();

        if (result && result.msg.toString().indexOf('wallet') > 0) {
          
          // Si pas de wallet trouvé, creation wallet puis rappel de la méthode
          const url = baseUrl + 'create-inapp-wallet?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;
          
          fetch(url, { signal: AbortSignal.timeout(5000) }).then(
            async (res) => {
              await res.json();

              setTimeout(() => {
                getInAppAccounts();
              }, 1500);
            }
          );

        } else {
          setInAppWalletContent([]);

          const itemNSA: WalletContent = {
            name: 'Nebula Stars Anthill',
            symbol: 'NSA',
            mint: Config.tokenNsaAddress,
            value: result.msg.nsa,
            price: null,
            price_last: null,
            link: ``,
            img: arrowUpCircle,
            parsed: true,
          };
      
          setInAppWalletContent(walletContent => [...walletContent, itemNSA]);
      
          const itemNSAN: WalletContent = {
            name: 'Nebula Stars Anthill Nucleus',
            symbol: 'NSAN',
            mint: Config.tokenNsanAddress,
            value: result.msg.nsan,
            price: null,
            price_last: null,
            link: ``,
            img: arrowUpCircle,
            parsed: true,
          };
      
          setInAppWalletContent(walletContent => [...walletContent, itemNSAN]);
        }
      }
    ).catch(() => {
      setShowAlertConnexion(true);
    });
  }

  /**
   * Mise à jour des données de balance du wallet
   * @param balance 
   */
  async function traitementBalance(balance: number) {
    const balanceString: string = (balance / decimals).toString();

    setWalletBalanceSOL(balanceString);

    const fakeMint = 'Sol1111111111111111';
    
    return await walletService.getSolUsdPrice().then(res => {

      // Ajout à la liste des crypto dispo dans le wallet
      const solToken: WalletContent = {
        name: 'Solana',
        symbol: 'SOL',
        mint: fakeMint,
        value: balanceString.toString(),
        price: res,
        price_last: res,
        link: `https://explorer.solana.com/address/${pubkey}?cluster=mainnet`,
        img: getDeviseIcon('SOL'),
        parsed: true,
      };
  
      if (isTokenNotInWallet(fakeMint)) {
        setWalletContent(walletContent => [...walletContent, solToken])
      }

      return solToken;
    });
    
  }

  /**
   * Traitement des données de pre-sale
   * @param total 
   */
  function traitementBuyData(total: any) {

    let tokenNSAInDevWallet: any = null;
    let tokenNSANInDevWallet: any = null;
    let totalNSAInDevWallet: any = 0;
    let totalNSANInDevWallet: any = 0;

    if (total && total.result && total.value) {
      tokenNSAInDevWallet = total.result.value?.find((token: any) => token.account.data.parsed.info.mint === Config.tokenNsaAddress);
      tokenNSANInDevWallet = total.result.value?.find((token: any) => token.account.data.parsed.info.mint === Config.tokenNsanAddress);
    } else if (total && total.value) {
      tokenNSAInDevWallet = total?.value?.find((token: any) => token.account.data.parsed.info.mint === Config.tokenNsaAddress);
      tokenNSANInDevWallet = total?.value?.find((token: any) => token.account.data.parsed.info.mint === Config.tokenNsanAddress);
    }

    if (userService && tokenNSAInDevWallet && tokenNSANInDevWallet) {
      
      totalNSAInDevWallet = tokenNSAInDevWallet.account?.data?.parsed?.info?.tokenAmount?.amount;
      totalNSANInDevWallet = tokenNSANInDevWallet.account?.data?.parsed?.info?.tokenAmount?.amount;
      
      const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;
      const url = baseUrl + 'gettoken?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;

      fetch(url, { signal: AbortSignal.timeout(5000) }).then(
        async (res) => {
          const result = await res.json();

          const totalInDevDatabase = result['total'] === null ? 0 : result['total'];
          
          const totalNSANSentFromAccount = 220000 - (totalNSANInDevWallet / 1000000000);
          const totalSentFromAccount = 1100000000 - (totalNSAInDevWallet / 1000000000);
          const totalSentFromAll = totalSentFromAccount + totalInDevDatabase;
          const remaining = 99000000 - totalSentFromAll;
          // const onePercent = 99000000 / 50;
          // const reduction = 50 - Math.round(totalSentFromAll / onePercent);
          // const reduction = 20;
          const reduction = 15;
          
          // console.log('totalNSANSentFromAccount', totalNSANSentFromAccount);

          setReduction(reduction.toString());
          setRemaining(remaining.toString());
          setTotalNSASent(totalSentFromAll.toString());
          setTotalNSANSent(totalNSANSentFromAccount.toString());
          tokenNSAInDevWallet = total?.value?.find((token: any) => token.account.data.parsed.info.mint === Config.tokenNsaAddress);

          return remaining;
        }
      ).catch((_e) => {
        console.log('debug: _e', _e);
        setIsLoadingWallet(false);
      }).finally(() => {
        setIsLoadingWallet(false);
      }
      );
    } else {
      setIsLoadingWallet(true);
    }
  }

  /**
   * Création du wallet in-app
   * @param email 
   * @param security 
   */
  function createWallet(email: any, security: any) {
    const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;
    const url = baseUrl + 'create-wallet?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;
  
    fetch(url, { signal: AbortSignal.timeout(5000) }).then(
      async (res) => {
        const result: any = await res.json();

        if (result && result.msg && (result.msg.indexOf('Nothing') > -1)) {
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: 'Account not valid.',
            buttons: ['OK'],
          });
        } else if (result && result.msg && (result.msg.indexOf('already') > -1)) {
          // TODO: récup la pubkey côté server
          setPubkey(await userService?.getPubkey());
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: `In-App Wallet already created. Your pubkey is: ${userService.pubkey}`,
            buttons: ['OK'],
          });
        } else if (result && result.pubkey && result.pubkey !== null) {

          setSeedkeyString(result.seedkey);
          setSeedkey(result.seedkey);
          setPubkey(result.pubkey);

          userService?.setSeedkey(result.seedkey);
          userService?.setPubkey(result.pubkey);

          // afficher la popin de seedkey
          setTimeout(() => {
            setShowAlertSeedKeyValue(true);
          }, 1000);

          // rafraichir le wallet
          setTimeout(() =>{
            refreshWallet();
          }, 2500);
        }
      })
      .catch((_e) => {
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: `Please connect your device to Internet. If you are already connected, servers may be temporarily down or application need to be updated. ${_e}`,
          buttons: ['OK'],
        });
      });
  }

  /**
   * Modification du bouton de sauvegrade de Seed Key
   * @param value 
   */
  function setShowAlertSeedKeyValue(value: boolean) {
    setShowAlertSeedKey(value);
    if (value) {
      const interval = setInterval(() => {
        const seedKeyAlert = document.getElementById('seedKeyAlert');

        if (seedKeyAlert !== null && seedKeyAlert.children[2]) {
          clearInterval(interval);

          const childNode = seedKeyAlert.children[2];
          const childChildNode = childNode.children[2];
          const childButtonNode = childChildNode.children[0];

          childButtonNode.setAttribute('disabled', 'disabled');
          const childButtonText = childButtonNode.children[0];
          childButtonText.innerHTML = 'Please wait 10 seconds !';

          setTimeout(() => {
            childButtonNode.removeAttribute('disabled');
            childButtonText.innerHTML = 'Yes, i have saved my Seed Key';
          }, 10000);
        }

      }, 150);
    }
  }

  /**
   * Bouton validation de sauvegarde de Seed Key
   * @returns 
   */
  function getAlertButton() {
    return [
      {
        text: 'Yes, i have saved my Seed Key',
        handler: () => {
          console.log('Seed key alert done');
        }
      }
    ];
  }

  /**
   * Affichage du messge de confirmation de création du wallet
   * @returns 
   */
  function getAlertMessage() {
    // const seedkeyObject = seedkeyString.split(' ');
    return 'In-App Wallet created with success on Solana blockchain ! Please backup your wallet seed key, write it down, THIS KEY IS SAVED TO YOUR APP DATA BUT CANNOT BE RECOVERED SO WRITE IT AND KEEP IT IN SAFE PLACE, NEVER TRANSMIT THIS DATA TO ANYBODY. Your Seed Key is: ' + seedkeyString;
  }

  /**
   * Calcul du montanr "pre-sale" suivant le bouton choisi
   * @param amount 
   */
  function getAmount(amount: String) {
    // TODO: à fusionner avec laméthode en dessous
    let total = Number(walletBalanceSOL);

    switch (amount) {
      case 'max':
        setAmount(total.toString());
        break;
        
      case 'half':
        const half: string = (Math.round(((total / 2) + Number.EPSILON) * 100) / 100).toString();
        setAmount(half);
        break;
        
      case 'quarter':
        const quarter: string = (Math.round(((total / 4) + Number.EPSILON) * 100) / 100).toString();
        setAmount(quarter);
        break;
    
      default:
        setAmount('0.00');
        break;
    }
  }

  /**
   * Calcul du montant "send" suivant le bouton choisi
   * Max
   * Half
   * Quarter
   * @param amount 
   */
  function getTransactionAmount(amount: String, isInApp: boolean = false) {
    let total: number;

    if (isInApp) {
      const deviseInApp: WalletContent = inAppWalletContent.find((d) => inAppCurrency === d.symbol.toLowerCase());
      total = Number(deviseInApp.value);

    } else if (transferToInAppChecked) {
      total = Number(walletBalanceNSA);
    } else {
      switch(isDevise) {
        case Config.tokenNsaAddress:
          total = Number(walletBalanceNSA);
          break;
        
        case Config.tokenNsanAddress:
          total = Number(walletBalanceNSAN);
          break;
  
        default:
          const devise: WalletContent = walletContent.find((d) => (isDevise === d.mint));
          total = Number(devise.value);
          break;
      }
    }

    switch (amount) {
      case 'max':
        setTransactionAmount(total.toString());
        break;
        
      case 'half':
        const half: string = (Math.round(((total / 2) + Number.EPSILON) * 100) / 100).toString();
        setTransactionAmount(half);
        break;
        
      case 'quarter':
        const quarter: string = (Math.round(((total / 4) + Number.EPSILON) * 100) / 100).toString();
        setTransactionAmount(quarter);
        break;
    
      default:
        setTransactionAmount('0.00');
        break;
    }
  }

  function calcPriorityFee(priorityFee: number) {
    const microLamports = priorityFee / 0.000000001;
    setPriorityFee(priorityFee);
    setMicroLamports(microLamports);
  }

  /**
   * Méthode pour acheter des NSA en pre-sale
   */
  async function buyTokens() {
    const solValues = await totalPresale();
    const solLimit = solValues['solLimit'];
    const solUsd = solValues['solUsd'];
    const amountToSend = Number(amount);

    if (amountToSend > Number(walletBalanceSOL)) {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: `You need a minimum of ${amount}  SOL in your wallet`,
        buttons: ['OK'],
      });
    } else if (amount === '0') {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'You need more than 0 SOL to get NSA tokens',
        buttons: ['OK'],
      });
    } else {
      if (amountToSend >= solLimit) {
        const receiver = new PublicKey(Accounts.sol);
        const seedBip39 = bip39.mnemonicToSeedSync(seedkey, ""); // (mnemonic, password)
        const keypair = Keypair.fromSeed(new Uint8Array(seedBip39.slice(0, 32)));

        const fee = await shared.calculateFeeTransfer(keypair);
        
        const priceWithReduction = startPrice - (startPrice * Number(reduction) / 100);
        const solAmountInUsd = (amountToSend - fee) * solUsd;
  
        const totalBought = solAmountInUsd / priceWithReduction;
  
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: `Current Solana USD price is: $ ${solUsd}`,
          buttons: ['OK'],
        });

        presentAlert({
          header: 'Message',
          subHeader: '',
          message: `Your Solana amount represent $ ${solAmountInUsd}`,
          buttons: ['OK'],
        });

        presentAlert({
          header: 'Message',
          subHeader: '',
          message: `Current NSA price with discount of ${reduction}% is: $ ${priceWithReduction}`,
          buttons: ['OK'],
        });
  
        alert('You want to send ' + amountToSend + ' SOL with ' + fee + ' SOL fees, to get NSA tokens with a reduction of ' + reduction
              + '% with the account ' + userService.email + ' with publicKey ' + userService.pubkey + '. This represent a total of ' + totalBought + ' NSA');

        await transferSolOrSpltokenOrBuyPreSale(keypair, receiver, fee, amountToSend, totalBought, Number(reduction), true);

      } else {
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: `Minimum amount to get NSA tokens is: ${solLimit} SOL`,
          buttons: ['OK'],
        });
      }
    }
  }

  /**
   * Méthode "send" pour transférer des fonds Sol
   */
  async function startTransaction() {

    if (transferToInAppChecked) {
      // TODO: Transfert vers l'in-app wallet

      const functionEnabled = false;

      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'Sending NSA to your In-App wallet is currently not possible.',
        buttons: ['OK'],
      });

      // Transfer to in-app wallet
      const url = baseUrl + 'sendto-inapp-wallet?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;

      if (functionEnabled) {
        fetch(url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(
            {
              'amount': transactionAmount,
            }
          ), 
          signal: AbortSignal.timeout(5000) 
        }).then(
          async (res) => {
            await res.json();
  
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: 'Send to your In-App wallet. It can take few minutes to update.',
              buttons: ['OK'],
            });
          }
        ).catch(() => {
          setShowAlertConnexion(true);
        });
      }
    } else {
      // Formulaire d'envoie de tokens
      if (showSendForm) {

        const amountToSend = Number(transactionAmount);

        // Si le destinataire est renseigné
        if (transactionAddress) {
          if (priorityFee <= Number(walletBalanceSOL)) {
            // todo: check si montant supérieur à total de la devise
            const selectedDevise = walletContent.find((d) => d.mint === isDevise);
            if (amountToSend <= Number(selectedDevise.value)) {
              // todo: faire la transaction
              // console.log('transfer mint', isDevise, amountToSend, selectedDevise);

              const destination = new PublicKey(transactionAddress);
              const seedBip39 = bip39.mnemonicToSeedSync(seedkey, ""); // (mnemonic, password)
              const keypair = Keypair.fromSeed(new Uint8Array(seedBip39.slice(0, 32)));

              // console.log('transfer data', destination, keypair);
              // Création transaction d'envoie des tokens
              await transferSolOrSpltokenOrBuyPreSale(keypair, destination, 0, amountToSend, 0, 0, false, false, selectedDevise.mint);

            } else {
              alert(`Not enought ${selectedDevise.name} in the wallet`);
            }
          } else {
            alert('Not enought SOL in wallet to cover priority fee');
          }
        } else {
          alert('Please enter a destination address');
        }
      } else {

        const solUsd: number = await walletService.getSolUsdPrice();
        const amountToSend = Number(transactionAmount);
      
        totalPresale();
    
        if (amountToSend > Number(walletBalanceSOL)) {
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: `You need to have ${amount} SOL in your wallet`,
            buttons: ['OK'],
          });
        } else if (transactionAmount === '0') {
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: 'You need to send more than 0 SOL',
            buttons: ['OK'],
          });
        } else {
          if (transactionAddress && transactionAddress.length > 0) {
            const receiver = new PublicKey(transactionAddress);
            const seedBip39 = bip39.mnemonicToSeedSync(seedkey, ""); // (mnemonic, password)
            const keypair = Keypair.fromSeed(new Uint8Array(seedBip39.slice(0, 32)));
    
            const fee = await shared.calculateFeeTransfer(keypair);
            
            const priceWithReduction = startPrice - (startPrice * Number(reduction) / 100);
            const solAmountInUsd = (amountToSend - fee) * solUsd;
      
            const totalBought = solAmountInUsd / priceWithReduction;
      
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: `You want to send ${amountToSend} SOL with fee of ${fee} SOL to ${receiver} with the account ${userService.email} with publicKey ${userService.pubkey} .`,
              buttons: ['OK'],
            });
      
            await transferSolOrSpltokenOrBuyPreSale(keypair, receiver, fee, amountToSend, totalBought, Number(reduction), false);

          } else {
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: 'Please enter a destination address.',
              buttons: ['OK'],
            });
          }
        }
      }
    }
  }

  /**
   * Create NSA asset dans le wallet
   */
  async function createSplTokenaccount(splToken: string) {
    
    const splTokenPublicKey = new PublicKey(splToken);
    const seedBip39 = bip39.mnemonicToSeedSync(seedkey, ""); // (mnemonic, password)
    const keypair = Keypair.fromSeed(new Uint8Array(seedBip39.slice(0, 32)));
    const fee = await shared.calculateFeeTransfer(keypair);
    let transaction: Transaction  = null;

    presentAlert({
      header: 'Message',
      subHeader: '',
      message: `This feature create a NSA asset in your wallet. To create this asset you need some SOL for the transaction fee. The current fee is: ${fee}. If you get any error please contact support on Telegram channel.`,
      buttons: ['OK'],
    });

    const mintToken = new Token(
      connectionMainnet,
      splTokenPublicKey,
      TOKEN_PROGRAM_ID,
      keypair
    );

    // let fromTokenAccount = null;

    let isAccountNeeded = false;

    switch (splToken) {
      case Config.tokenNsaAddress:
        isAccountNeeded = needNSAaccount;
        break;

      case Config.tokenNsanAddress:
        isAccountNeeded = needNSANaccount;
        break;
    
      default:
        isAccountNeeded = false;
        break;
    }
    
    if (isAccountNeeded && Number(walletBalanceSOL) > 0.02) {
        
      const fromTokenAccount = await mintToken.getOrCreateAssociatedAccountInfo(
        keypair.publicKey
      );

      const toTokenAccount = await mintToken.getOrCreateAssociatedAccountInfo(
        keypair.publicKey
      );
      
      transaction = new Transaction().add(
        Token.createTransferInstruction(
          TOKEN_PROGRAM_ID,
          fromTokenAccount.address,
          toTokenAccount.address,
          keypair.publicKey,
          [],
          0
        )
      );

      transaction.recentBlockhash = (await connectionMainnet.getLatestBlockhash('confirmed')).blockhash;
      transaction.feePayer = keypair.publicKey;
      // const currentFee = (await connectionMainnet.getFeeForMessage(tx.compileMessage(), 'confirmed')).value || 0;

      const modifyComputeUnits = ComputeBudgetProgram.setComputeUnitLimit({
        units: Transactions.computerUnits
      });

      //tx.instructions.pop();

      // Ajout recent block hash
      transaction.recentBlockhash = (await connectionMainnet.getLatestBlockhash('confirmed')).blockhash;
      // Ajout compute units
      transaction.add(modifyComputeUnits);
      // Ajout frais priorité
      let addPriorityFee = await calculatePriorityFee();
      transaction.add(addPriorityFee);

      // Sign transaction, broadcast, and confirm
      setIsLoadingWallet(true);

      await connectionMainnet.sendTransaction(
        transaction,
        [keypair],
        {
          skipPreflight: true,
          maxRetries: 0
        }
      ).then((signature) => {
        setIsLoadingWallet(false);

        presentAlert({
          header: 'Message',
          subHeader: '',
          message: 'NSA asset created in your wallet. Wait 5s and refresh your wallet. Don\'t press the button a second time.',
          buttons: ['OK'],
        });
        
        setNeedNSAaccount(false);
        setTimeout(() =>{
          refreshWallet();
        }, 5000);
      }).catch((error) => {
        console.log('debug:error', error.message);
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: `Cannot create NSA asset in the wallet: ${error.message}`,
          buttons: ['OK'],
        });
      });
      setIsLoadingWallet(false);
    } else if (needNSAaccount && Number(walletBalanceSOL) < 0.02) {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'You need more than 0.02 SOL in your wallet',
        buttons: ['OK'],
      });
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'NSA asset already available in your wallet',
        buttons: ['OK'],
      });
    }
  }

  async function calculatePriorityFee() {
    const resultRecentPrioritizationFees: Response = await walletService.getRecentPrioritizationFees();
    const prioritizationFeeJson = await resultRecentPrioritizationFees.json();
    const prioritizationFeeObjects = prioritizationFeeJson['result'] as PrioritizationFeeObject[];

    let addPriorityFee = ComputeBudgetProgram.setComputeUnitPrice({
      microLamports: Transactions.microLamports
    });

    if (prioritizationFeeObjects.length > 0) {
      // Extract slots and sort them
      // const slots = prioritizationFeeObjects.map(feeObject => feeObject.slot).sort((a, b) => a - b);
      // Extract slots range
      // const slotsRangeStart = slots[0];
      // const slotsRangeEnd = slots[slots.length - 1];

      // Calculate the average including zero fees
      // const averageFeeIncludingZeros = prioritizationFeeObjects.length > 0
      //     ? Math.floor(prioritizationFeeObjects.reduce((acc, feeObject) => acc + feeObject.prioritizationFee, 0) / prioritizationFeeObjects.length)
      //     : 0;

      // Filter out prioritization fees that are equal to 0 for other calculations
      const nonZeroFees = prioritizationFeeObjects
          .map(feeObject => feeObject.prioritizationFee)
          .filter(fee => fee !== 0);

      // Calculate the average of the non-zero fees
      // const averageFeeExcludingZeros = nonZeroFees.length > 0
      //     ? Math.floor(nonZeroFees.reduce((acc, fee) => acc + fee, 0) / nonZeroFees.length )
      //     : 0;

      // Calculate the median of the non-zero fees
      const sortedFees = nonZeroFees.sort((a, b) => a - b);
      let medianFee = 0;
      if (sortedFees.length > 0) {
          const midIndex = Math.floor(sortedFees.length / 2);
          medianFee = sortedFees.length % 2 !== 0
              ? sortedFees[midIndex]
              : Math.floor((sortedFees[midIndex - 1] + sortedFees[midIndex]) / 2);
      }

      // You can use averageFeeIncludingZeros, averageFeeExcludingZeros, and medianFee in your transactions script
      // console.log(`Average Prioritization Fee (including slots with zero fees): ${averageFeeIncludingZeros} micro-lamports.`);
      // console.log(`Average Prioritization Fee (excluding slots with zero fees): ${averageFeeExcludingZeros} micro-lamports.`);
      // console.log(`Median Prioritization Fee (excluding slots with zero fees): ${medianFee} micro-lamports.`);

      addPriorityFee = ComputeBudgetProgram.setComputeUnitPrice({
        microLamports: medianFee
      });
    }

    return addPriorityFee;
  }

  /**
   * Transfert de SOL ou Transfert pour presale
   * @param keypair 
   * @param to 
   * @param fee 
   * @param amount 
   * @param totalBought 
   * @param reduction 
   * @param isPreSale 
   * @param isPlatform
   */
  async function transferSolOrSpltokenOrBuyPreSale(keypair: Keypair, to: PublicKey, fee: number, amount: number, totalBought: number, reduction: number, isPreSale: boolean = true, isPlatform: boolean = false, addressSplToken?: string) {

    const lamportsAvecFee = Math.round(LAMPORTS_PER_SOL * (amount - fee));

    // console.log("debug: transferSolOrSpltokenOrBuyPreSale", keypair, to, amount, fee, lamportsAvecFee, totalBought, reduction, isPreSale, addressSplToken);

    setSendTransactionBtnDisabled(true);
    let transaction: Transaction = null;

    if (keypair && to && fee !== undefined && amount) {

      setIsLoadingWallet(true);
      
      if (isPreSale) {
        transaction = new Transaction().add(
          SystemProgram.transfer({
            fromPubkey: keypair.publicKey,
            toPubkey: to,
            lamports: lamportsAvecFee,
          })
        );
      } else {
        // console.log('not presale, transaction simulation, sending spl token mint: ', addressSplToken);

        // Simulation de transaction
        transaction = new Transaction().add(
            SystemProgram.transfer({
                fromPubkey: keypair.publicKey,
                toPubkey: to,
                lamports: amount * LAMPORTS_PER_SOL,
            })
        );
        // console.log('transaction: ', transaction);

        transaction.recentBlockhash = (await connectionMainnet.getLatestBlockhash('confirmed')).blockhash;
        transaction.feePayer = keypair.publicKey;
        // const currentFee = (await connectionMainnet.getFeeForMessage(transaction.compileMessage(), 'confirmed')).value || 0;

        const modifyComputeUnits = ComputeBudgetProgram.setComputeUnitLimit({
          units: Transactions.computerUnits
        });
        // console.log('transaction2: ', transaction);

        // Nettoyage simulation transaction
        transaction.instructions.pop();

        // console.log('transaction3: ', transaction);

        if (addressSplToken !== 'Sol1111111111111111') {

          const mintToken = new Token(
            connectionMainnet,
            new PublicKey(addressSplToken),
            TOKEN_PROGRAM_ID,
            keypair
          );

          const fromTokenAccount = await mintToken.getOrCreateAssociatedAccountInfo(
            keypair.publicKey
          );

          const toTokenAccount = await mintToken.getOrCreateAssociatedAccountInfo(
            to
          );

          // Create a test transaction to calculate fees
          const numberDecimals = await getNumberDecimals(addressSplToken);
          // console.log('numberDecimals: ', numberDecimals);

          // Initialisation de la vraie transaction
          transaction = new Transaction().add(
            Token.createTransferInstruction(
              TOKEN_PROGRAM_ID,
              fromTokenAccount.address,
              toTokenAccount.address,
              keypair.publicKey,
              [],
              amount * Math.pow(10, numberDecimals)
            )
          );
          console.log('transaction not sol: ', transaction);

        } else {
          // transaction sol
          transaction = new Transaction().add(
            SystemProgram.transfer({
              fromPubkey: keypair.publicKey,
              toPubkey: to,
              lamports:  amount * LAMPORTS_PER_SOL
            })
          );
          console.log('transaction sol: ', transaction);
        }

        // Ajout recent block hash
        transaction.recentBlockhash = (await connectionMainnet.getLatestBlockhash('confirmed')).blockhash;
        // Ajout compute units
        transaction.add(modifyComputeUnits)
        // Ajout frais priorité
        let addPriorityFee = await calculatePriorityFee();
        transaction.add(addPriorityFee);
      }
  
      // Sign transaction, broadcast, and confirm
      await connectionMainnet.sendTransaction(
          transaction,
          [keypair],
          {
            skipPreflight: true,
            maxRetries: 0
          }
      ).then((signature) => {
        console.log('signature', signature);
        setIsLoadingWallet(false);
  
        if (isPreSale) {
          if (signature) {
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: 'Transaction send.',
              buttons: ['OK'],
            });
            window.open('https://explorer.solana.com/tx/' + signature + '?cluster=mainnet');
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: 'Your transaction has been saved to the server queue. You will receive your NSA in 24/48h. The tokens are not transferred automatically, the procedure is manual and takes some time, thank you for your comprehension. For any problem please contact support on Telegram.',
              buttons: ['OK'],
            });
      
            const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;
            const url = baseUrl + 'buytoken?email=' + userService.email + '&security=' + userService.security + '&signature=' + signature + '&totalbought=' + totalBought + '&reduction=' + reduction + '&v=' + Config.version;
      
            fetch(url, { signal: AbortSignal.timeout(5000) }).then(async (res) => {
              const result: any = await res.json();
      
              if (result && result.msg && (result.msg.indexOf('Invalid') > -1)) {
                presentAlert({
                  header: 'Message',
                  subHeader: '',
                  message: 'Account not valid.',
                  buttons: ['OK'],
                });
              } else if (result && result.msg && (result.msg.indexOf('activation') > -1)) {
                presentAlert({
                  header: 'Message',
                  subHeader: '',
                  message: `Your transaction data are saved to the server queue. Your transaction signature is "${signature}", email: ${email} for a total of ${totalBought} NSA.`,
                  buttons: ['OK'],
                });
              }
            })
            .catch((_e) => {
              presentAlert({
                header: 'Message',
                subHeader: '',
                message: `Please connect your device to Internet. If you are already connected, servers may be temporarily down or application need to be updated. ${_e}`,
                buttons: ['OK'],
              });
            })
            .finally(() => {
            });
      
          } else {
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: 'Transaction error.',
              buttons: [
                {
                  text: 'Open',
                  role: 'open',
                  handler: () => {
                    gotoSolanaExplorer(signature);
                  },
                },
                {
                  text: 'Quit',
                  role: 'quit',
                  handler: () => {},
                } 
              ],
            }).finally(() => {
              setShowBuyForm(false);
              setShowDepositForm(false);
              setInAppShowSendForm(false);
              setShowSendForm(false);
            });
          }
        } else {
          if (signature) {
            // console.log('signature', signature);
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: 'Transaction was send. Your wallet will refresh in 50 seconds.',
              buttons: [
                {
                  text: 'Open',
                  role: 'open',
                  handler: () => {
                    gotoSolanaExplorer(signature);
                  },
                },
                {
                  text: 'Quit',
                  role: 'quit',
                  handler: () => {},
                } 
              ],
            }).finally(() => {
              setShowBuyForm(false);
              setShowDepositForm(false);
              setInAppShowSendForm(false);
              setShowSendForm(false);
            });
          }
        }
      }).catch(() => {
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: 'Transaction error, please contact support.',
          buttons: ['OK'],
        });
      }).finally(() => {
        setIsLoadingWallet(false);
        setSendTransactionBtnDisabled(false);
        setTimeout(() => {
          refreshWallet();
        }, 50000)
      });
    } else {
      setIsLoadingWallet(false);
      setSendTransactionBtnDisabled(false);
      if (!to) {
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: 'Please enter a destination address.',
          buttons: ['OK'],
        });
      } else if (!amount) {
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: 'Please enter an amount.',
          buttons: ['OK'],
        });
      }
    }
  }

  function gotoSolanaExplorer(signature) {
    window.open('https://explorer.solana.com/tx/' + signature + '?cluster=mainnet');
  }

  /**
   * Calcul du total pre-sale pour afficher les données
   */
  async function totalPresale() {

    const solUsd: number = await walletService.getSolUsdPrice();
    const limit = 25; // Limite minimum 25$
    let solLimit: number = limit / solUsd;
    
    setIsLoadingWallet(true);

    connectionMainnet
      .getParsedTokenAccountsByOwner(
        new PublicKey(accountPubkey),
        { programId: TOKEN_PROGRAM_ID }
      )
      .then((allAccountsInWallet) => {
        traitementBuyData(allAccountsInWallet);
      }
    );

    setSolLimit(solLimit);
    
    return {
      solLimit: solLimit,
      solUsd: solUsd
    };
  }

  /**
   * Mise à jour des données affichées pour le pre-sale
   */
  function updatePresaleData() {
    setIsLoadingWallet(true);
    totalPresale();
  }

  async function getNumberDecimals(mintAddress: string):Promise<number> {
    const info = await connectionMainnet.getParsedAccountInfo(new PublicKey(mintAddress));
    const result = (info.value?.data as ParsedAccountData).parsed.info.decimals as number;
    return result;
  }

  /**
   * Mise à jour des données du portefeuille
  */
  async function refreshWallet() {
    let fetching: string[] = []
    let totalDevises = 0;
    setWalletContent([]);
    let walletContentCopy: WalletContent[] = [];
    setCoingeckoLogo('primary');

    setShowLoadingDots(true);
    // console.log('start loading wallet');

    // Get SOL balance
    getSolanaBalance().then(async (solToken) => {

      // Récupération token SOL
      if (solToken) {
        walletContentCopy.push(solToken);
      }

      await walletService.getOurTokenAccountsByOwner(userService.pubkey).then(async (response) => {
        const tokenAccounts: any = await response.json();
        const tokens: {pubkey:PublicKey;account:AccountInfo<ParsedAccountData>;}[] = tokenAccounts?.result?.value;
        tokens.forEach(token => {
          const parsedToken: ParsedAccount = token?.account?.data?.parsed;
          console.log('parsedToken', parsedToken.info);
          const tokenAmount = parsedToken.info.tokenAmount;
          if (tokenAmountIsNotNFT(tokenAmount) && parsedToken) {
            const mintAddress:string = parsedToken?.info?.mint;
            const tokenBalance: number = parsedToken?.info?.tokenAmount?.uiAmount;
            const ownerPubkey = parsedToken?.info?.owner;

            if (isNSA(mintAddress) && isTokenNotInWallet(mintAddress)) {
              fetching.push('loading');
    
              let itemNsaParsed: WalletContent = {
                name: 'Nebula Stars Anthill',
                symbol: 'NSA',
                mint: mintAddress,
                value: tokenBalance.toString(),
                price: '0.015727272',
                price_last: '0.015727272',
                link: `https://explorer.solana.com/address/${mintAddress}?cluster=mainnet`,
                img: getDeviseIcon('NSA'),
                parsed: true,
              };
              setWalletBalanceNSA(tokenBalance.toString());
              setNeedNSAaccount(false);
    
              setWalletContent(walletContent => [...walletContent, itemNsaParsed]);
              // Recupération token NSA
              walletContentCopy.push(itemNsaParsed);
              totalDevises = totalDevises + Number(getTotalValue(itemNsaParsed.price, itemNsaParsed.value));
    
              fetching.pop();
            } else if (isNSAN(mintAddress) && isTokenNotInWallet(mintAddress)) {
              fetching.push('loading');
    
              let itemNsanParsed: WalletContent = {
                name: 'Nebula Stars Anthill Nucleus',
                symbol: 'NSAN',
                mint: mintAddress,
                value: tokenBalance.toString(),
                price: '78.63636',
                price_last: '78.63636',
                link: `https://explorer.solana.com/address/${mintAddress}?cluster=mainnet`,
                img: getDeviseIcon('NSAN'),
                parsed: true,
              };
    
              setWalletBalanceNSAN(tokenBalance.toString());
              setNeedNSANaccount(false);
    
              setWalletContent(walletContent => [...walletContent, itemNsanParsed]);
              // Recupération token NSAN
              walletContentCopy.push(itemNsanParsed);
              totalDevises = totalDevises + Number(getTotalValue(itemNsanParsed.price, itemNsanParsed.value));
              
              fetching.pop();
            } else if (isTokenNotInWallet(mintAddress)) {
              fetching.push('loading');
  
              let itemParsed: WalletContent = {
                name: mintAddress,
                symbol: '???',
                mint: mintAddress,
                value: tokenBalance.toString(),
                price: '0.000',
                price_last: '0.000',
                link: `https://explorer.solana.com/address/${mintAddress}?cluster=mainnet`,
                img: getDeviseIcon(null),
                parsed: false,
              };
  
              setWalletContent(walletContent => [...walletContent, itemParsed]);
              // Recupération token Token
              walletContentCopy.push(itemParsed);
              totalDevises = totalDevises + Number(getTotalValue(itemParsed.price, itemParsed.value));
              
              fetching.pop();
            }

          }
        });
      });
      
      // await walletService.getAllTokensAccountsByOwner(userService.pubkey).then(async (accounts) => {

      //   const parsedAccounts: {'result':{pubkey:PublicKey;account:AccountInfo<Buffer|ParsedAccountData>;}[]} = await accounts.json();

      //   console.log('accounts', accounts, parsedAccounts.result);

      //   parsedAccounts?.result?.forEach((asset, i) => {
          
      //     // Parse the account data
      //     const parsedAccountInfo:any = asset?.account?.data;
  
      //     if (isNotNFT(parsedAccountInfo)) {
      //       const mintAddress:string = parsedAccountInfo?.parsed?.info?.mint;
      //       const tokenBalance: number = parsedAccountInfo?.parsed?.info?.tokenAmount?.uiAmount;
      //       const ownerPubkey = parsedAccountInfo?.parsed?.info?.owner;
            
      //       if (isNSA(mintAddress) && isTokenNotInWallet(mintAddress)) {
      //         fetching.push('loading');
    
      //         let itemNsaParsed: WalletContent = {
      //           name: 'Nebula Stars Anthill',
      //           symbol: 'NSA',
      //           mint: mintAddress,
      //           value: tokenBalance.toString(),
      //           price: '0.015727272',
      //           price_last: '0.015727272',
      //           link: `https://explorer.solana.com/address/${ownerPubkey}?cluster=mainnet`,
      //           img: getDeviseIcon('NSA'),
      //           parsed: true,
      //         };
      //         setWalletBalanceNSA(tokenBalance.toString());
      //         setNeedNSAaccount(false);
    
      //         setWalletContent(walletContent => [...walletContent, itemNsaParsed]);
      //         // Recupération token NSA
      //         walletContentCopy.push(itemNsaParsed);
      //         totalDevises = totalDevises + Number(getTotalValue(itemNsaParsed.price, itemNsaParsed.value));
    
      //         fetching.pop();
      //       } else if (isNSAN(mintAddress) && isTokenNotInWallet(mintAddress)) {
      //         fetching.push('loading');
    
      //         let itemNsanParsed: WalletContent = {
      //           name: 'Nebula Stars Anthill Nucleus',
      //           symbol: 'NSAN',
      //           mint: mintAddress,
      //           value: tokenBalance.toString(),
      //           price: '78.63636',
      //           price_last: '78.63636',
      //           link: `https://explorer.solana.com/address/${ownerPubkey}?cluster=mainnet`,
      //           img: getDeviseIcon('NSAN'),
      //           parsed: true,
      //         };
    
      //         setWalletBalanceNSAN(tokenBalance.toString());
      //         setNeedNSANaccount(false);
    
      //         setWalletContent(walletContent => [...walletContent, itemNsanParsed]);
      //         // Recupération token NSAN
      //         walletContentCopy.push(itemNsanParsed);
      //         totalDevises = totalDevises + Number(getTotalValue(itemNsanParsed.price, itemNsanParsed.value));
              
      //         fetching.pop();
      //       } else if (isTokenNotInWallet(mintAddress)) {
      //         fetching.push('loading');
  
      //         let itemParsed: WalletContent = {
      //           name: mintAddress,
      //           symbol: '???',
      //           mint: mintAddress,
      //           value: tokenBalance.toString(),
      //           price: '0.000',
      //           price_last: '0.000',
      //           link: `https://explorer.solana.com/address/${ownerPubkey}?cluster=mainnet`,
      //           img: getDeviseIcon(null),
      //           parsed: false,
      //         };
  
      //         setWalletContent(walletContent => [...walletContent, itemParsed]);
      //         // Recupération token Token
      //         walletContentCopy.push(itemParsed);
      //         totalDevises = totalDevises + Number(getTotalValue(itemParsed.price, itemParsed.value));
              
      //         fetching.pop();
      //       }
      //     }
      //   });
      // });  
  
      const interval = setInterval(() => {
        // console.log('wallet loading', fetching, fetching.length);
  
        if (fetching.length === 0) {
          setShowLoadingDots(false);
          setTotal(Number(totalDevises?.toFixed(3)));
          
          userService.setWalletContentData(walletContentCopy);

          // Parse les données manquantes des spl-tokens
          try {
            parsingTokensCoingecko(walletContentCopy, totalDevises).then((res) => {
              // console.log('Parsing is finished: ', res);
            }).finally(() => {
              userService.setWalletContentData(walletContentCopy);
              userService.setWalletContentCalled();
            });
          } catch (error) {
            console.log("Coingecko error");
          }

          // console.log('wallet loading finished');
          clearInterval(interval);
        } else {
          // console.log('waiting fetch to finish');
        }
      }, 450);
    });

    // Wallet In-App récupération des devises
    getInAppAccounts();
  }

  function parsingTokensCoingecko(walletContentCopy: WalletContent[], totalDevises: number) {

    const fetching: boolean[] = [];
    
    walletContentCopy.forEach((token: WalletContent, index) => {
      if (token.parsed === false) {
        fetching.push(true);
        walletService.getTokenInfo(token.mint).then(res => {
          token.name = res.name;
          token.price = res.market_data?.current_price?.usd;
          token.symbol = res.symbol?.toUpperCase();
          token.img = res.image?.small;

          totalDevises = totalDevises + Number(getTotalValue(token.price, token.value));

          // setCoingeckoLogo('primary');
          fetching.pop();
        }).catch(() => {
          setCoingeckoLogo('danger');
          fetching.pop();
        });
      }
    });

    return new Promise(function(resolve, reject) {
      const interval = setInterval(() => {

        if (fetching.length === 0) {
          clearInterval(interval);
          setWalletContent(walletContentCopy);
          userService.setWalletContentData(walletContentCopy);

          setTotal(Number(totalDevises?.toFixed(3)));

          resolve(true);
        } else {
          console.log('wait parsing to finish');
        }
      }, 450);
    });
  }

  function isNSA(mintAddress) {
    return isToken(mintAddress, Config.tokenNsaAddress);
  }

  function isNSAN(mintAddress) {
    return isToken(mintAddress, Config.tokenNsanAddress);
  }

  function isToken(mintAddress, compareAddress) {
    return mintAddress === compareAddress;
  }

  function isTokenNotInWallet(mintAddress) {
    return true;
    // return !walletContent.find((predicate) => predicate.mint === mintAddress);
  }

  function isNotNFT(parsedAccountInfo) {
    const tokenAmount = parsedAccountInfo?.parsed?.info?.tokenAmount;
    return tokenAmountIsNotNFT(tokenAmount);
  }

  function tokenAmountIsNotNFT(tokenAmount: TokenAmount) {
    return tokenAmount?.decimals !== 0 && tokenAmount?.amount !== '1';
  }

  function manualRefreshWallet() {

    const refreshButton = document.getElementById('refresh-button');
    const refreshButtonIsDisabled = refreshButton.attributes.getNamedItem('disabled');
    const refreshButtonDefaultInner = refreshButton.innerHTML;

    if (!refreshButtonIsDisabled || refreshButtonIsDisabled?.nodeValue === 'false') {
      refreshButton.setAttribute('disabled', 'true');
      setRefreshing(true);
      refreshWallet();
    }

    // Décompte du temps de disabled
    let temps = 60;
    const timer = setInterval(() => {
      if (temps === 0) {
        refreshButton.innerHTML = refreshButtonDefaultInner;
        refreshButton.setAttribute('disabled', 'false');
        setRefreshing(false);
        clearInterval(timer);
      } else {
        refreshButton.innerHTML = temps.toString();
        temps--;
      }
    }, 1000);
  }

  function showHideWallet(isInAppWallet: boolean) {
    if (isInAppWallet) {
      document.getElementById('in-app-wallet').style.display = 'block';
      document.getElementById('solana-mainnet-wallet').style.display = 'none';
    } else {
      document.getElementById('solana-mainnet-wallet').style.display = 'block';
      document.getElementById('in-app-wallet').style.display = 'none';
    }
    setShowInAppWallet(isInAppWallet);
  }

  function changeInAppCurrency(currency: any) {
    setInAppCurrency(currency);
  }

  function getDeviseIcon(devise: string) {
    const lowerCaseDevise = devise ? devise.toLocaleLowerCase() : 'nsa';
    const assetPath = '/assets/wallet';
    const suffix = 'logo.png';
    const finalUrl = `${assetPath}/${lowerCaseDevise}_${suffix}`;

    // if (checkIfImageExists(finalUrl)) {
    if (devise) {
      return finalUrl;
    } else {
      return `${assetPath}/unknown_${suffix}`;
    }
  }

  function getCoinGeckoDeviseIcon(devise: string) {
    return (devise)
      ? devise
      : '/assets/wallet/unknown_logo.png';
  }

  // function checkIfImageExists(url) {
  //   const img = new Image();
  //   img.src = url;
    
  //   if (img.complete) {
  //     return true;
  //   } else {
  //     img.onload = () => {
  //       return true;
  //     };
      
  //     img.onerror = () => {
  //       return false;
  //     };
  //   }
  // }

  function getReadableValue(value: string, toFixed: number = 3) {
    return Number(value) % 1 ? Number(value)?.toFixed(toFixed) : value;
  }

  function getTotalValue(price: string, value: string) {
    console.log('num', price, value);
    return ((price ? Number(price) : 0) * (value ? Number(value) : 0)).toString();
  }

  function getPercentage(price: string, price_last: string) {
    // const v2 = Number(price);
    // const v1 = Number(price_last);

    // const p1 = v1 - v2;
    // const p2 = (v1 + v2) / 2;

    // const result = p1 / p2 * 100;

    // return result.toFixed(2) + '%';
    return '';
  }

  function isDeviseAllowed(item, invert) {
    if (item.mint === Config.tokenNsaAddress || item.mint === Config.tokenNsanAddress) {
      return invert ? false : true;
    } else {
      return invert ? true : false;
    }
  }

  return (
    <IonPage>
      <IonContent fullscreen className="container-wallet-content">

        { !isRefreshing &&
          <IonRefresher slot="fixed" closeDuration={'1000ms'} pullFactor={0.5} pullMin={200} pullMax={500} onIonRefresh={manualRefreshWallet}>
            <IonRefresherContent></IonRefresherContent>
          </IonRefresher>
        }

        { showUpdateDownload &&
          <div style={{zIndex: 9999, position: 'fixed', marginTop: '150px', marginLeft: 'calc(50% - 232.3px / 2)', background: 'black', display: 'flex', flexDirection: 'column', borderRadius: '15px', padding: '15px'}}>
            <h1 style={{marginTop: 0}}>Info</h1>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>An update is available.</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>Your current version is: {updateService.versionInstalled}</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>The latest version is: {updateService.versionServer}</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}><b>Proceed to the update ?</b></p>
            <div style={{textAlign: 'right', paddingTop: '.7rem'}}>
              <button style={{width: '50px', padding: '7px 10px', borderRadius: '5px'}} onClick={() => setShowUpdateDownload(false)}>No</button>
              <button style={{width: '50px', padding: '7px 10px', borderRadius: '5px', marginLeft: '5px', background: 'rgb(133,231,133)', color: 'black'}} onClick={() => {setShowDownload(true); updateService.updateApplication(userService)}}>Yes</button>
            </div>
          </div>
        }
        <IonLoading message="Downloading update please wait... ~15mb" isOpen={showDownload}></IonLoading>

        {/* Barre d'entête */}
        <IonGrid className="wallet-bar">
          <IonRow>
            <IonCol size="2">
              <IonImg className="wallet-bar-img" src="/assets/icon/new_icon.png" />
            </IonCol>
            <IonCol size="8">
              <IonRow style={{ height: '60px'}}>
                <IonCol size="6" style={{ paddingTop: '0', paddingBottom: '0' }}>
                  <IonButton id="open-my-in-app-wallet" className={showInAppWallet ? 'active': 'inactive'} color="primary" style={{ height: '52px', width: '100%' }} onClick={
                    () => showHideWallet(true)
                  }>In-App <IonIcon icon={walletOutline} slot="end"></IonIcon></IonButton>
                </IonCol>
                <IonCol size="6" style={{ paddingTop: '0', paddingBottom: '0' }}>
                  <IonButton id="open-my-mainnet-wallet" className={!showInAppWallet ? 'active': 'inactive'} color="primary" style={{ height: '52px', width: '100%' }} onClick={
                    () => showHideWallet(false)
                  }>Main <IonIcon icon={walletSharp} slot="end"></IonIcon></IonButton>
                </IonCol>
              </IonRow>
            </IonCol>
          </IonRow>
        </IonGrid>
        
        {/* {
          isLoadingWallet &&
          <IonLoading
            cssClass='my-custom-class'
            isOpen={isLoadingWallet}
            message={'Loading'}
            duration={0}
            spinner={'dots'}
          />
        } */}

        <div className="container-wallet">

          <div id="solana-mainnet-wallet" className="container-wallet-common">

            <IonAlert
              id="seedKeyAlert"
              isOpen={showAlertSeedKey}
              header={'Wallet'}
              subHeader={'Backup your Seed Key'}
              message={getAlertMessage()}
              buttons={getAlertButton()}
              backdropDismiss={false}
            />

            <div className="common-buttons">
              <IonCard onClick={() => showSend()}>
                <IonIcon color="primary" className="icon-icon-list" icon={arrowUpCircle} />
                <IonCardHeader>
                  <IonCardSubtitle>Transfer</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              <IonCard onClick={() => showDeposit()}>
                <IonIcon color="primary" className="icon-icon-list" icon={arrowDownCircle} />
                <IonCardHeader>
                  <IonCardSubtitle>Deposit</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              { (userService.email && userService.email.indexOf('ogle.bot') === -1) &&
                <IonCard onClick={() => showBuy()}>
                  <IonIcon color="primary" className="icon-icon-list" icon={add} />
                  <IonCardHeader>
                    <IonCardSubtitle><b>BUY</b></IonCardSubtitle>
                  </IonCardHeader>
                </IonCard>
              }

              <IonCard onClick={() => createWallet(email, security)}>
                <IonIcon color="primary" className="icon-icon-list" icon={wallet} />
                <IonCardHeader>
                  <IonCardSubtitle>Create</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              <IonCard onClick={() => exploreAddress()}>
                <IonIcon color="primary" className="icon-icon-list" icon={timeOutline} />
                <IonCardHeader>
                  <IonCardSubtitle>Histo.</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

            </div>

            {/* Bouton create NSA account */}
            { needNSAaccount && userService.pubkey &&
                <div className="compteur-adresse">
                  <IonButton color="secondary" onClick={() => createSplTokenaccount(Config.tokenNsaAddress)}>Create NSA asset in the wallet</IonButton>
                </div>
            }

            {/* Bouton create NSAN account */}
            { needNSANaccount && userService.pubkey &&
                <div className="compteur-adresse color-black">
                  <IonButton color="primary" onClick={() => createSplTokenaccount(Config.tokenNsanAddress)}>Create NSAN asset in the wallet</IonButton>
                </div>
            }

            {/* { !showSendForm && !showDepositForm && (userService.email && userService.email.indexOf('ogle.bot') === -1) &&
              <p className="presale-advert">To buy NSA token before market start is available, <br />click <u>BUY button</u>. An in-app wallet with some SOL in it is required. {needNSAaccount ? 'To create the NSA asset in your wallet press the "Create NSA asset in the wallet" button. If you need help, contact support on Telegram thanks.'  : ''}</p>
            } */}

            { showSendForm &&
              <div className='send'>

                <IonItem>
                  <IonCheckbox slot="start" onIonChange={e => setTransferToInAppChecked(e.detail.checked)}></IonCheckbox>
                  <IonLabel>Transfer NSA to In-App wallet</IonLabel>
                </IonItem>

                { !transferToInAppChecked &&
                  <div>
                    <IonItem>
                      <IonSelect placeholder="Select devise" onIonChange={e => setDevise(e.detail.value)}>
                        {walletContent.map((item, i) => (
                          // On retire les desises non autorisées
                          isDeviseAllowed(item, true) &&
                            <IonSelectOption disabled={isDeviseAllowed(item, false)} key={'devise_'+i} value={item.mint}>
                              {/* <IonImg src={getDeviseIcon(item.devise)} style={{width: '30px'}} className="devise-border" /> */}
                              <IonImg src={item.img}></IonImg> {item.name}
                            </IonSelectOption>
                        ))}
                      </IonSelect>
                    </IonItem>
                    <IonItem>
                      <IonLabel>Address:</IonLabel>
                      <IonInput placeholder="Receiver address..." value={transactionAddress}  onIonChange={e => setTransactionAddress(e.detail.value!)} type={'text'}></IonInput>
                      <IonButton onClick={() => setOpenQrScan(true)}><IonIcon icon={camera}></IonIcon></IonButton>
                    </IonItem>
                    <IonItem>
                      <IonLabel position="floating">Compute Units:</IonLabel>
                      <IonInput disabled={true} placeholder="96000" inputmode={'numeric'} value={computeUnits} onIonChange={e => setComputeUnits(Number(e.detail.value!))} type={'text'}></IonInput>
                    </IonItem>
                    <IonItem>
                      <IonLabel position="floating">Priority fee (SOL):</IonLabel>
                      <IonInput disabled={true} placeholder="0.000025" inputmode={'numeric'} value={priorityFee} onIonChange={e => calcPriorityFee(Number(e.detail.value!))} type={'text'}></IonInput>
                    </IonItem>
                  </div>
                }

                <IonItem>
                  <IonLabel position="floating">Amount:</IonLabel>
                  <IonInput placeholder="Amount to send..." inputmode={'numeric'} value={transactionAmount} onIonChange={e => setTransactionAmount(e.detail.value!)} type="number"></IonInput>
                </IonItem>

                { isDevise &&
                  <>
                    <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('max')}>Maximum</IonButton>
                    <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('half')}>Half</IonButton>
                    <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('quarter')}>Quarter</IonButton>
                  </>
                }
                { isLoadingWallet &&
                  <IonSpinner name="dots" className="dots-spinner send-transaction"></IonSpinner>
                }
                <IonButton className="transaction sendBtn" color="secondary" disabled={sendTransactionBtnDisabled || !isDevise || (!priorityFee || priorityFee === 0)} onClick={() => startTransaction()}><IonIcon icon={wallet} style={{marginRight: '5px'}} /> Send transaction</IonButton>
              </div>
            }

            { isOpenQRScan &&
            
              <div className="qrscanner-modal">
                <IonHeader style={{display: 'flex'}}>
                  <IonToolbar>
                    <IonTitle>QRCode scanner</IonTitle>
                    <IonButtons slot="end">
                      <IonButton onClick={() => setOpenQrScan(false)}>Close</IonButton>
                    </IonButtons>
                  </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                  <QrReader
                    className="qr-reader"
                    delay={100}
                    style={{
                      height: 240,
                      width: 320,
                    }}
                    onError={(error) => console.error(error)}
                    onScan={(data) => handleScan(data)}
                    />
                </IonContent>
              </div>
            }

            { showDepositForm &&
              <div className="deposit">
                <p className="title">Your address:</p>
                <p className="pubkey-hash">{userService.pubkey} <CopyToClipboard text={userService.pubkey}>
                  <IonIcon className="icon-icon-list" icon={copy} onClick={
                    () => { presentAlert({
                      header: 'Message',
                      subHeader: '',
                      message: `Your address "${userService.pubkey}" has been copied to clipboard`,
                      buttons: ['OK'],
                    }) }
                    } /></CopyToClipboard>
                </p>
                <div className="qrcode-background">
                  <QRCode
                    className="qrcode"
                    value={userService.pubkey}
                  />
                </div>
              </div>
            }

            { showBuyForm &&
              <div className='buy'>

                <IonButton className="transaction" color="secondary" onClick={() => updatePresaleData()}>Update service data</IonButton>
                <p className="sub-label-title first">Service status is: <u>{preSaleStatus}</u>.</p>
                <p className="sub-label-title middle">Presale status is: <u>Public</u>.</p>
                {/* <p className="sub-label-title middle">Remaining: <b>{remainingJoinDays}</b> days.</p> */}
                <p className="sub-label-title middle">Min. SOL to buy NSA:<br/><b>SOL {minSolToBuy.toFixed(4)}</b></p>
                <p className="sub-label-title middle">Current discount:<br/><b>{reduction}%</b></p>
                <p className="sub-label-title middle">Discount price for 1 NSA:<br/><b>USDT {(startPrice / 100 * (100 - Number(reduction))).toFixed(9)}</b></p>
                {/* <p className="sub-label-title middle">NSA remaining in pre-sale:<br/><b>{remaining}</b></p> */}
                <p className="sub-label-title last">NSA currently distributed is:<br/><b>{totalNSASent}</b></p>
                {/* <p className="sub-label-title last">NSAN currently distributed is:<br/><b>{totalNSANSent}</b></p> */}
                
                <IonItem>
                  <IonLabel position="floating">SOL Amount:</IonLabel>
                  <IonInput type="number" placeholder="Enter the amount..." value={amount} onIonChange={e => setAmount(e.detail.value!)}></IonInput>
                </IonItem>

                <IonButton className="amount-button" color="secondary" onClick={() => getAmount('max')}>Maximum</IonButton>
                <IonButton className="amount-button" color="secondary" onClick={() => getAmount('half')}>Half</IonButton>
                <IonButton className="amount-button" color="secondary" onClick={() => getAmount('quarter')}>Quarter</IonButton>

                <IonButton className="transaction" color="secondary" onClick={() => buyTokens()}><IonIcon icon={wallet} style={{marginRight: '5px'}}/> Get tokens</IonButton>
              </div>
            }

            { userService.pubkey &&
              <div id="common-history" className="common-history">
                <div className="header-container">
                  <h1 className="title">
                    Total
                    <IonButton color="primary" className="position-icon-eye" onClick={() => hideValue()}>
                      <IonIcon icon={eye} />
                    </IonButton>
                    <IonButton color="primary" id="refresh-button" className="position-icon-refresh" onClick={() => manualRefreshWallet()}>
                      <IonIcon icon={refresh} />
                    </IonButton>
                    <IonButton color={coingeckoLogo} id="cg-button" className="position-icon-cg" onClick={() => alert(`CoinGecko API quota for 1 minute ${coingeckoLogo === 'primary' ? 'not ': ''}exceeded.`)}>
                      <IonLabel>Quota</IonLabel>
                    </IonButton>
                  </h1>
                  <h3 className="total">${total}</h3>
                </div>
                
                { showLoadingDots &&
                  <IonSpinner name="dots" className="dots-spinner"></IonSpinner>
                }
                <IonList>

                  {walletContent.map((item, i) => (
                    <IonItem className="token-item" key={'history' + i} style={{'--inner-padding-end': 0}}>
                      <IonLabel style={{margin: 0}}>
                        <IonGrid style={{padding: 0}}>
                          <IonRow class="ion-justify-content-between">
                            <IonCol size="7" style={{display: 'flex', flexDirection: 'row'}}>
                              <IonImg src={getCoinGeckoDeviseIcon(item.img)} className="devise-icon devise-border"></IonImg>
                              <div className="devise-name">
                                <span className="tiny-link" onClick={() => { window.open(item.link); }}>{item.name ?? item.mint}</span>
                                <span className="devise-name-price">${item.price} <span className="percentage">{getPercentage(item.price, item.price_last)}</span></span>
                              </div>
                            </IonCol>
                            <IonCol size="5" class="devise-value align-right" style={{margin: 'auto 0x', fontSize: '1rem'}}>
                              <span className="devise-value-total">{getReadableValue(item.value)} {item.symbol === item.name ? 'unknown' : item.symbol}</span>
                              <span className="devise-value-price">${getReadableValue(getTotalValue(item.price, item.value))}</span>
                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      </IonLabel>
                    </IonItem>
                  ))}

                </IonList>
              </div>
              }
          </div>

          <div id="in-app-wallet" className="container-wallet-common">

            { showAlertConnection &&
              <div className="no-connection wallet">
                <span>
                  <h1>Please check your internet connection.</h1>
                  <p>If your connection is working, it is likely that the servers are under maintenance.</p>
                  <p>Please visit the support channels for information.</p>
                  <h2>Your wallet remains usable during maintenance.</h2>
                  <IonButton color="secondary" style={{ height: "52px" }} onClick={() => showHideWallet(false)}><IonIcon icon={enter} style={{ paddingRight: "5px" }}></IonIcon> Wallet</IonButton>
                </span>
              </div>
            }

            <div className="common-buttons">
              <IonCard onClick={() => showInAppSend()}>
                <IonIcon color="primary" className="icon-icon-list" icon={arrowUpCircle} />
                <IonCardHeader>
                  <IonCardSubtitle>Transfer</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              <IonCard disabled={true} onClick={() => alert('Stacking tokens is currently not available from the in-app wallet.')}>
                <IonIcon color="primary" className="icon-icon-list" icon={arrowDownCircle} />
                <IonCardHeader>
                  <IonCardSubtitle>Stack</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>
            </div>

            { needNSAaccount && userService.pubkey &&
                <div className="compteur-adresse">
                  <IonButton color="secondary" onClick={() => createSplTokenaccount(Config.tokenNsaAddress)}>Create NSA asset in the wallet</IonButton>
                </div>
            }

            { needNSANaccount && userService.pubkey &&
                <div className="compteur-adresse color-black">
                  <IonButton color="primary" onClick={() => createSplTokenaccount(Config.tokenNsanAddress)}>Create NSAN asset in the wallet</IonButton>
                </div>
            }

            { showInAppSendForm &&
              <div className='send'>

                <IonItem>
                  <IonSelect defaultValue="nsa" onIonChange={(e) => { changeInAppCurrency(e.detail.value) }}>
                    <IonSelectOption value="nsa">NSA</IonSelectOption>
                    <IonSelectOption value="nsan">NSAN</IonSelectOption>
                  </IonSelect>
                </IonItem>
                
                <IonItem>
                  <IonLabel position="floating">Enter Amount:</IonLabel>
                  <IonInput placeholder="Enter the amount..." value={transactionAmount}  onIonChange={e => setTransactionAmount(e.detail.value!)} type="number"></IonInput>
                </IonItem>

                <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('max', true)}>Maximum</IonButton>
                <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('half', true)}>Half</IonButton>
                <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('quarter', true)}>Quarter</IonButton>

                <IonButton className="transaction" color="secondary" disabled={true} onClick={() => startTransaction()}><IonIcon icon={wallet} style={{marginRight: '5px'}} /> Send transaction</IonButton>
              </div>
            }

            { userService.pubkey &&
              <div id="common-history" className="common-history">
                <div className="header-container">
                  <h1 className="title">
                    Wallet content
                    <IonButton color="primary" style={{left: '98px'}} className="position-icon-eye" onClick={() => alert('Hide in-app value')}>
                      <IonIcon icon={eye} />
                    </IonButton>
                    <IonButton color="primary" style={{left: '140px'}} id="refresh-button" className="position-icon-refresh" onClick={() => alert('Refresh in-app wallet')}>
                      <IonIcon icon={refresh} />
                    </IonButton>
                  </h1>
                  <h3 className="total">0</h3>
                </div>

                <IonList>

                  {inAppWalletContent.map((item, i) => (
                    <IonItem className="token-item" key={'history' + i} style={{'--inner-padding-end': 0}}>
                      <IonLabel style={{margin: 0}}>
                        <IonGrid style={{padding: 0}}>
                          <IonRow class="ion-justify-content-between">
                            <IonCol size="7" style={{display: 'flex', flexDirection: 'row'}}>
                              <IonImg src={getDeviseIcon(item.symbol)} className="devise-icon devise-border"></IonImg>
                              <div className="devise-name">
                                <span className="tiny-link" onClick={() => { window.open(item.link); }}>{item.name}</span>
                                <span className="devise-name-price">${item.price} <span className="percentage">{getPercentage(item.price, item.price_last)}</span></span>
                              </div>
                            </IonCol>
                            <IonCol size="5" class="devise-value align-right" style={{margin: 'auto 0x', fontSize: '1rem'}}>
                              <span className="devise-value-total">{getReadableValue(item.value)} {item.symbol === item.name ? '???' : item.symbol}</span>
                              <span className="devise-value-price">${getReadableValue(getTotalValue(item.price, item.value))}</span>
                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      </IonLabel>
                    </IonItem>


                  ))}

                </IonList>
              </div>
              }

          </div>
        </div>

      </IonContent>
    </IonPage>
  );
};

export default Wallet;

export type WalletContent = {
  name: string;
  symbol: string;
  mint: string;
  value: string;
  price: string;
  price_last: string;
  link: string;
  img: string;
  parsed: boolean;
};